





































































































































































































































import debounce from 'lodash/debounce'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import EventBus from '@/plugins/EventBus'
import { timeout, maskMoney } from '@/utils/common'
import { ItemTaxaAluguel } from '@/types/_'
import HistoricoSituacaoStore from '@/components/HistoricoSituacao/Store/HistoricoSituacaoStore'
import TaxaAluguelParametrosDataTable from "@/components/RemuneracaoMedica/financeiro/components/TaxaAluguelParametrosDataTable.vue"

@Component({
  components: {
    TaxaAluguelParametrosDataTable
  },
})

export default class ViewFinanceiroTaxaAluguel extends Vue {
  itemTaxaAluguelMode: string = 'CREATE'
  searchPrestador: string = ''
  itemParametroAplicacaoMode: string = 'CREATE'
  tabs: string = 'principal'

  loadEditarItemTaxaAluguel: string = ''
  get loadingEditarItemTaxaAluguel() { return this.loadEditarItemTaxaAluguel }
  set loadingEditarItemTaxaAluguel(value: string) { this.loadEditarItemTaxaAluguel = value }

  loadSelectPrestadores: boolean = false
  get loadingSelectPrestadores() { return this.loadSelectPrestadores }
  set loadingSelectPrestadores(value: boolean) { this.loadSelectPrestadores = value }

  prestadoresDebounced = debounce(async (filtro: string) => {
    await this.getFinanceiroStore.getPrestadorTaxaAluguelAll({ limite: 20, filtro })
  }, 500)

  loadDataTable: boolean = false
  get loadingDataTable() { return this.loadDataTable }
  set loadingDataTable(value: boolean) { this.loadDataTable = value }

  loadDeleteItemTaxaAluguel: boolean = false
  get loadingDeleteItemTaxaAluguel() { return this.loadDeleteItemTaxaAluguel }
  set loadingDeleteItemTaxaAluguel(value: boolean) { this.loadDeleteItemTaxaAluguel = value }

  loadHistorico: string = ''
  get loadingHistorico() { return this.loadHistorico }
  set loadingHistorico(value: string) { this.loadHistorico = value }

  itemToDelete: string = ''
  get itemToDeleteId() { return this.itemToDelete }
  set itemToDeleteId(value: string) { this.itemToDelete = value }

  modalDeleteItem: boolean = false
  get showModalDeleteItem() { return this.modalDeleteItem }
  set showModalDeleteItem(value: boolean) { this.modalDeleteItem = value }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get itemsTabelaTaxaAluguel() {
    return [
      { text: 'Prestador', value: 'nomePrestador', align: 'left', sortable: false },
      { text: 'Tipo', value: 'tipo', align: 'left', sortable: false },
      { text: 'Valor', value: 'valor', align: 'center', sortable: false },
      { text: 'Ações', value: '', align: 'center', sortable: false },
    ]
  }

  get itemsTaxaAluguel() {
    return this.getFinanceiroStore.itemsTaxaAluguel
  }

  get prestadores() {
    return this.getFinanceiroStore.prestadoresLista
  }

  async fetchPrestadores() {
    const filtro = (this.searchPrestador || '').trim()

    if (filtro.length < 3) {
      if (!filtro) {
        this.loadingSelectPrestadores = true
        await this.getFinanceiroStore.getPrestadorTaxaAluguelAll({ limite: 20 })
        this.loadingSelectPrestadores = false
      }

      return
    }

    this.loadingSelectPrestadores = true
    this.prestadoresDebounced(filtro)
  }

  get paginaParametros() {
    return this.getFinanceiroStore.parametrosAplicacaoTaxaAluguelPagina
  }

  set paginaParametros(value: number) {
    this.getFinanceiroStore.setParametrosAplicacaoTaxaAluguelPagina(value)
  }

  get qtdPorPaginaParametros() {
    return this.getFinanceiroStore.parametrosAplicacaoTaxaAluguelQtdPorPagina
  }

  showModalCriarParametroAplicacao(){
    this.itemParametroAplicacaoMode = 'CREATE'
    this.getFinanceiroStore.clearItemParametroAplicacaoTaxaAluguel()
    this.getFinanceiroStore.clearOriginalItemParametroAplicacaoTaxaAluguel()
    this.getFinanceiroStore.setModal({ name: 'criarParametrosAplicacao', value: true })
  }

  onEditParametroAplicacao() {
    this.itemParametroAplicacaoMode = 'EDIT'
  }

  criarItemTaxaAluguel() {
    this.itemTaxaAluguelMode = 'CREATE'
    this.getFinanceiroStore.clearItemTaxaAluguel()
    this.getFinanceiroStore.setModal({ name: 'criarEditarItemTaxaAluguel', value: true })
  }

  async editarItemTaxaAluguel(item: any) {
    this.itemTaxaAluguelMode = 'EDIT'
    this.getFinanceiroStore.clearItemTaxaAluguel()
    this.loadingEditarItemTaxaAluguel = item.id
    await timeout(500)
    
    this.getFinanceiroStore.setOriginalItemTaxaAluguel(this.formatOriginalItem({ ...item }) as ItemTaxaAluguel)
    this.getFinanceiroStore.setItemTaxaAluguel(this.formatOriginalItem({ ...item })as ItemTaxaAluguel)
    this.getFinanceiroStore.setModal({ name: 'criarEditarItemTaxaAluguel', value: true })
    this.loadingEditarItemTaxaAluguel = ''
  }

  get getHistoricoSituacaoStore() {
    return getModule(HistoricoSituacaoStore, this.$store)
  }

  async showHistory(solicitacaoId: string) {
    this.loadingHistorico = solicitacaoId
    this.getHistoricoSituacaoStore.setIdForLoadItems(solicitacaoId)
    await this.getHistoricoSituacaoStore.getHistoricoCadastroAluguel(solicitacaoId)
    this.loadingHistorico = ''
  }

  formatOriginalItem(item) {
    return {
      id: item.id,
      prestadorId: item.prestadorId,
      fontePagadoraId: item.fontePagadoraId,
      tipo: item.tipo.key,
      valor: item.valor,
    }
  }

  async apagarItemTaxaAluguel() {
    this.loadingDeleteItemTaxaAluguel = true
    const response = await this.getFinanceiroStore.deleteTaxaAluguel(this.itemToDeleteId)
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: `Item apagado com sucesso! ${String.fromCodePoint(0x1f642)}`, icon: 'done', color: '#2E7D32' })
      this.showModalDeleteItem = false
    } else {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: response.message ? `${response.message} ${String.fromCodePoint(0x1f615)}` : `Ocorreu um problema com essa requisição. ${String.fromCodePoint(0x1f615)}`,
        icon: 'warning',
        color: '#C62828',
      })
    }
    this.loadingDeleteItemTaxaAluguel = false
  }

  async getAllItems() {
    this.loadingDataTable = true
    await this.getFinanceiroStore.getTaxaAluguelAll()
    this.loadingDataTable = false
  }

  async getItemsTaxaAluguel(prestador: any) {
    if (prestador === undefined) {
      this.getFinanceiroStore.clearTaxaAluguelPrestador()
    } else {
      this.getFinanceiroStore.setTaxaAluguelPrestador(prestador)
    }

    this.loadingSelectPrestadores = true
    this.getFinanceiroStore.clearItemsTaxaAluguel()
    this.getPagina = 1
    const response = await this.getFinanceiroStore.getTaxaAluguelAll()

    if (!response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || `Ocorreu um erro ao buscar resultados... ${String.fromCodePoint(0x1f615)}`, icon: 'warning', color: '#C62828' })
    }
    this.loadingSelectPrestadores = false
  }

  async getParametrosAplicacao(){
    await this.getFinanceiroStore.getParametrosAplicacaoTaxaAluguel()
    if (this.paginaParametros > this.itemsLengthParametros) {
      this.paginaParametros = this.itemsLengthParametros
    }
  }

  async init() {
    EventBus.$emit('setLoadingRequest', { status: true, text: 'Carregando' })
    this.getFinanceiroStore.clearItemsTaxaAluguel()
    this.getFinanceiroStore.clearItemTaxaAluguel()
    this.getFinanceiroStore.clearPrestadoresLista()
    this.getFinanceiroStore.getFontePagadoraAll()
    this.searchPrestador = ''
    await this.getFinanceiroStore.getPrestadorTaxaAluguelAll({limite: 20})
    await this.getFinanceiroStore.getCentroDeCusto()
    await this.getParametrosAplicacao()
    await this.getAllItems()
    this.$ga.event('financeiro', 'acessar-tabela-taxa-aluguel', this.$user.profile.email)
    EventBus.$emit('clearLoadingRequest')
  }

  async mounted() {
    await this.init()
  }

  /**
   * Paginação
   */
  get itemsLength() {
    return Math.ceil(this.getFinanceiroStore.itemsTabelaTaxaAluguelTotal / this.getFinanceiroStore.qtdPorPagina)
  }

  get itemsLengthParametros() {
    const total = this.getFinanceiroStore.parametrosAplicacaoTaxaAluguelTotal
    return Math.max(1, Math.ceil(total / this.qtdPorPaginaParametros))
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  get getPagina() {
    return this.getFinanceiroStore.itemsTabelaTaxaAluguelPagina
  }

  set getPagina(value: number) {
    this.getFinanceiroStore.setItemsTabelaTaxaAluguelPagina(value)
  }

  async getResults(pagina: number) {
    this.loadingDataTable = true
    this.getPagina = pagina
    await this.getFinanceiroStore.getTaxaAluguelAll()
    this.loadingDataTable = false
  }

  async getResultsParametros(pagina: number) {
    this.paginaParametros = pagina
    await this.getParametrosAplicacao()
  }

  setItemToDelete(id: string) {
    this.itemToDeleteId = id
    this.showModalDeleteItem = !this.showModalDeleteItem
  }

  maskMoneyUtil(value) {
    return maskMoney(value)
  }

  getTableRowClasses(data: any) {
    const classes: string[] = []

    if (!data.prestadorId) {
      classes.push('backoffice-financeiro-list-table-row__taxaPadrao')
    }

    return classes
  }

  @Watch('prestadores')
  onChangePrestadores(value) {
    if (value) this.loadingSelectPrestadores = false
  }

  @Watch('showModalDeleteItem')
  onChangeShowModalDeleteItem(value) {
    if (!value) this.itemToDeleteId = ''
  }
}
